.loading {
  @apply --mx-bg(var(--m-gray-light));
  animation-name: pulse;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: var(--m-ease);

  &[data-border='true'] {
    @apply --mx-borderColor(var(--m-gray-heavy));
  }
}

@keyframes pulse {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
